import { Outlet } from "react-router-dom";

import { Footer, Navigation } from "components";

import "./PublicLayout.scss";
import GlassBottomBar from "../../components/GlassBottomBar/GlassBottomBar";

export const PublicLayout = () => {
  return (
    <>
      <Navigation />
      <div className="public-outlet-wrapper">
        <Outlet />
      </div>
      <Footer className="public-footer" />
      {/* <GlassBottomBar /> */}
    </>
  );
};
